{
	"showButtonTitle": "Anzeigen",
	"hideButtonTitle": "Verbergen"
}
